import React, { Component } from 'react';
import SliderSlick from "react-slick";
import server from '../server';

class Home extends Component {

  state = {

    loading: true,

    image: "assets/img/home/1.jpg",
    image2: "assets/img/home/2.jpg",
    
    page: false
  }

  componentDidMount() {
    if( this.state.page !== false )
      return 0;

    fetch(server.uri+'page', server.params)
      .then( response => response.json() )
      .then( data =>
        this.setState({
          loading: false,
          page: data,
        })
      )
  }
  
  render() {

    if( this.state.loading )
      return <div className="loading"></div>;
    
    const page = this.state.page,
      sliderSettings = {
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },{
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }
        ]
      };
      
    return (
      <div className="page">

        <section className="welcome img__container">
          <div className="img_bg" style={{ backgroundImage: `url('${this.state.image}')` }}></div>
          <img src="assets/imgs/logo2.svg" alt="ICORE"/>
        </section>

        <article className="article article__aboutus">
          <section>

            <h2 className="page__title">{ page.aboutus.pagetitle }</h2>

            <div className="row row_20">
              <div className="col-md-6">
                <div className="page__content" dangerouslySetInnerHTML={{ __html: page.aboutus.content }}></div>
              </div>
              <div className="col-md-6">
                <div className="page__content" dangerouslySetInnerHTML={{ __html: page.aboutus.extracontent }}></div>
              </div>
            </div>
          </section>
          <hr/>

          { page.aboutus.list ? <section>
            <ul className="list">
              { page.aboutus.list.map( (v,i) => (
                <li key={i}>
                  <div className="list__item">
                    <h3 className="list__title">{ v.title }</h3>
                    <p className="list__description">{ v.description }</p>
                  </div>
                </li>
              ))}
            </ul>
          </section> : '' }
        </article>

        { page.partners ? <section className="partners img__container">
          <div className="img_bg" style={{ backgroundImage: `url('${this.state.image2}')` }}></div>
          <SliderSlick {...sliderSettings}>
            { page.partners.map( (v,i) => (
              <div key={i}>
                <div className="partners__item">
                  <a href={ v.description } target="_blank" rel="noopener noreferrer">
                    <img src={v.image} alt={v.title} title={v.title}/>
                  </a>
                </div>
              </div>
            ))}
          </SliderSlick>
        </section> : '' }

        { page.infobase ? <article className="article article__infobase">
          <section>
            <h2 className="page__title">{ page.infobase.pagetitle }</h2>
            <div className="page__content" dangerouslySetInnerHTML={{ __html: page.infobase.content }}></div>
          </section>

          <section>
            <ul className="list">
              { page.infobase.list.map( (v,i) => (
                <li key={i}>
                  <div className="list__item">
                    <h3 className="list__title">{ v.title }</h3>
                    <p className="list__description">{ v.description }</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        </article> : '' }
      </div>
    );
  }
}
export default Home;
